import { render, staticRenderFns } from "./mitCallback.vue?vue&type=template&id=76f872a2&scoped=true"
import script from "./mitCallback.vue?vue&type=script&lang=js"
export * from "./mitCallback.vue?vue&type=script&lang=js"
import style0 from "./mitCallback.vue?vue&type=style&index=0&id=76f872a2&prod&lang=less"
import style1 from "./mitCallback.vue?vue&type=style&index=1&id=76f872a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f872a2",
  null
  
)

export default component.exports